import React from 'react'
import style from './ContactUs.module.scss'
import {Link} from "react-router-dom";

export default function ContactUs({ setActiveCategory }) {

    const handleClick = (category) => {
        setActiveCategory(category);
    };

    return (
        <div className={style.contactUs}>
            <div className='container'>
               <div className={style.innerContainer}>
                   <span className={style.subtitle}>Нужна консультация специалиста?</span>
                   <Link onClick={() => handleClick('contacts')} to="/services" className={style.link}>Связаться</Link>
               </div>
            </div>
        </div>
    )
}
